import React, { useEffect, useState } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import useAuthEffect from "../../hook/useAuthEffect";
import { useDispatch, useSelector } from "react-redux";
import { fetchTitle } from "../../redux/ducks/title";
import { fetchTitleProjects } from "../../redux/ducks/project";
import { fetchGlossariesByTitle } from "../../redux/ducks/glossary";
import { fetchMemoriesByTitle } from "../../redux/ducks/memory";
import useStatusThunk from "../../hook/useStatusThunk";
import { extractIDsDataAsArray, mapData } from "../../helpers/mapRow";
import RouteHeader from "../../components/dumb/RouteHeader";
import Projects from "../../components/dumb/tables/Projects";
import Glossaries from "../../components/dumb/tables/Glossaries";
import Memories from "../../components/dumb/tables/Memories";
import SetTitleName from "../../components/smart/buttonPopups/SetTitleName";
import DeleteTitle from "../../components/smart/buttonPopups/DeleteTitle";

const TitleRoute = ({ match }) => {
    const titleID = match.params.titleID;
    const dispatch = useDispatch();

    const title = useSelector(state => state.title.titles[titleID]);

    //Projects
    const projects = useSelector(state => state.project.projects);
    const titleProjects = title?.projects;

    //Glossaries
    const glossaries = useSelector(state => state.glossary.glossaries);
    const titleGlossaries = useSelector(state => state.title.titles[titleID]?.glossaries);

    //Memories
    const memories = useSelector(state => state.memory.memories);
    const titleMemories = useSelector(state => state.title.titles[titleID]?.memories);

    //Fetch title
    const [dispatchFetchTitle, status, error] = useStatusThunk(fetchTitle);

    const [projectRows, setProjectRows] = useState([]);
    const [glossaryRows, setGlossaryRows] = useState([]);
    const [memoryRows, setMemoryRows] = useState([]);

    //Fetch title
    useAuthEffect(async () => {
        dispatchFetchTitle({ titleID });
    }, []);

    //Fetch tables after title is fetched
    useEffect(() => {
        if (status == "success") {
            dispatch(fetchTitleProjects({ titleID }));
            dispatch(fetchGlossariesByTitle({ titleID }));
            dispatch(fetchMemoriesByTitle({ titleID }));
        }
    }, [status]);

    //Project rows
    useEffect(() => {
        if (titleProjects && projects) setProjectRows(extractIDsDataAsArray(titleProjects, projects));
    }, [titleProjects, projects]);

    //Glossary rows
    useEffect(() => {
        if (titleGlossaries) {
            setGlossaryRows(Object.keys(titleGlossaries).map(titleID => ({
                ID: titleID,
                ...glossaries[titleID],
                contractorWrite: titleGlossaries[titleID].contractorWrite
            })));
        }
    }, [titleGlossaries, glossaries]);

    //Memory rows
    useEffect(() => {
        if (titleMemories) {
            const tm = {};
            Object.keys(titleMemories).forEach(titleMemoryID => {
                tm[titleMemoryID] = {
                    ...memories[titleMemoryID],
                    penalty: titleMemories[titleMemoryID].penalty,
                    write: titleMemories[titleMemoryID].write
                }
            });
            setMemoryRows(mapData(tm));
        }
    }, [memories, titleMemories]);

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="titles" />
            </div>

            <div className="column column--primary">
                <RouteHeader title={<React.Fragment>{title?.name} <SetTitleName titleID={titleID}/> <br /><DeleteTitle titleID={titleID} /></React.Fragment>} />

                <Projects rows={projectRows} titleID={titleID} />

                <Glossaries rows={glossaryRows} titleID={titleID} />

                <Memories rows={memoryRows} titleID={titleID} />
            </div>
        </div>
    )
}

export default TitleRoute;